export default __webpack_public_path__ + "static/media/idea-title-5.77f8b9d4.png";